export default "__VITE_ASSET__003ee0ae__"